var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#D77504",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7299 11.5101L23.4899 15.0301C23.7299 15.5201 24.3699 15.9901 24.9099 16.0801L28.0999 16.6101C30.1399 16.9501 30.6199 18.4301 29.1499 19.8901L26.6699 22.3701C26.2499 22.7901 26.0199 23.6001 26.1499 24.1801L26.8599 27.2501C27.4199 29.6801 26.1299 30.6201 23.9799 29.3501L20.9899 27.5801C20.4499 27.2601 19.5599 27.2601 19.0099 27.5801L16.0199 29.3501C13.8799 30.6201 12.5799 29.6701 13.1399 27.2501L13.8499 24.1801C13.9799 23.6001 13.7499 22.7901 13.3299 22.3701L10.8499 19.8901C9.38991 18.4301 9.85991 16.9501 11.8999 16.6101L15.0899 16.0801C15.6199 15.9901 16.2599 15.5201 16.4999 15.0301L18.2599 11.5101C19.2199 9.60014 20.7799 9.60014 21.7299 11.5101Z",
    stroke: "#D77504",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier);
export default __webpack_public_path__ + "static/media/tier.76ca6e96b15b1ef5274532be18229d50.svg";
export { ForwardRef as ReactComponent };